<template>
  <div class="input-container">
    <div class="input-container__prepend">
      <slot name="prepend" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
  margin-bottom: 1rem;

  &__prepend {
    position: absolute;
    top: 12px;
    left: 8px;
    z-index: 1;
  }
}
</style>